
import { includesValidator } from '../../common/utils/validator';

const CheckboxSizes = {
  Large: 'large',
  Small: 'small',
};

export default {
  name: 'BbCheckbox',
  props: {
    size: {
      type: String,
      default: CheckboxSizes.Large,
      validator: includesValidator(CheckboxSizes),
    },
    label: {
      type: String,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Boolean,
      default: false,
    },
    isIndeterminate: {
      type: Boolean,
      default: false,
    },
    checkedicon: {
      type: String,
      default: 'icon-checkbox-filled',
    },
    uncheckedIcon: {
      type: String,
      default: 'icon-checkbox-blank-outlined',
    },
    indeterminateIcon: {
      type: String,
      default: 'icon-checkbox-indeterminate-outlined',
    },
  },
  computed: {
    checkboxValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
